/* eslint no-shadow: 0 */
export enum OrderStatus {
  OPENNED = 0,
  WAITING_PAYMENT = 1,
  WITHOUT_ORDER = 2,
}
